import { yupResolver } from "@hookform/resolvers/yup"
import CloseIcon from "@mui/icons-material/Close"
import { Box, Button, DialogTitle, IconButton } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { memo, useEffect, useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {  useSelector } from "react-redux"
import * as yup from "yup"
import { UserAuth } from "../../context/AuthContext"
import CustomSearchSelect from "../CustomSearchSelect"
import CustomTextField from "../CustomTextField"


const ModalVacacionesEquipo = memo(({ open, handleClose, vacacion, onSubmit}) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))
  const { empleado } = UserAuth()

  const loadAprobarRechazarVacacionEquipoSelector = useSelector((store) => store.vacaciones.loadAprobarRechazarVacacionEquipo)

  const [idAprobador1, setIdAprobador1] = useState("")
  const [idAprobador2, setIdAprobador2] = useState("")
  const [idAprobador3, setIdAprobador3] = useState("")

  const [aprobacion1, setAprobacion1] = useState(0);
  const [aprobacion2, setAprobacion2] = useState(0);
  const [aprobacion3, setAprobacion3] = useState(0);

  const defaultValues = {
    tipoDeLicencia: null,
    fechaSolicitudModal: null,
    subperiodovacacionaldefinido: null,
    diasSolicitados: null,
    fechaHastaModal: null,
    nombreAprobador1: null,
    aprobacion1: 0,
    iDnombreAprobador1: null,
    nombreAprobador2: null,
    iDnombreAprobador2: null,
    aprobacion2: 0,
    nombreAprobador3: null,
    iDnombreAprobador3: null,
    aprobacion3: 0,
    usuarioPortalAprobador1: null,
    usuarioPortalAprobador2: null,
    usuarioPortalAprobador3: null,
  }

  const validacionSchema = yup.object().shape({
    tipoDeLicencia: yup.object({ value: yup.string().required("Requerido") }),
    fechaSolicitudModal: yup.string().required("Required"),
    // subperiodovacacionaldefinido: yup.object({ value: yup.string().required("Requerido") }),
    subperiodovacacionaldefinido: yup.object().when('tipoDeLicencia', {
      is: (value) => value && value.label === 'Vacaciones',
      then: yup.object().shape({
        value: yup.string().required("Requerido"),
      }),
      otherwise: yup.object().nullable(),
    }),
    diasSolicitados: yup.string().required("Por favor indica los dias solicitados."),
  })

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const { handleSubmit, reset } = methods

  useEffect(() => {
    reset(vacacion)
    if (Object.keys(vacacion).length > 0) {
      setIdAprobador1(vacacion.iDnombreAprobador1)
      setIdAprobador2(vacacion.iDnombreAprobador2)
      setIdAprobador3(vacacion.iDnombreAprobador3)
    }
    reset({
      ...vacacion,
      aprobacion1: aprobacion1,
      aprobacion2: aprobacion2,
      aprobacion3: aprobacion3,
    });
  }, [vacacion, reset, aprobacion1, aprobacion2, aprobacion3])

  const aprobarVacacionesEquipo = (datos) =>{
    onSubmit(datos)
  }

  return (
    <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect options={[vacacion.tipoDeLicencia]} type="text" name="tipoDeLicencia" lab="Tipo de Licencia" disabled />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                type="date"
                readOnly={true}
                name="fechaSolicitudModal"
                label="Fecha de solicitud"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica la fecha de solicitud."
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={[vacacion.subperiodovacacionaldefinido]}
                type="text"
                name="subperiodovacacionaldefinido"
                lab="Subperiodo vacacional definido"
                disabled
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                readOnly={true}
                type="number"
                name="diasSolicitados"
                label="Dias Solicitados"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica los dias solicitados."
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
              <CustomTextField Component={TextField} type="date" readOnly={true} name="fechaHastaModal" label="Fecha hasta" />
            </Grid>
            <Typography variant="h5">Aprobación</Typography>
            {idAprobador1 === empleado.empleadoid && (
              <>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
                  <CustomTextField Component={TextField} name="nombreAprobador1" label="Aprobador 1" />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                      ¿Que acción desea realizar?
                    </Typography>
                    <Box
                      sx={{
                        minWidth: "100%",
                        display: "flex",
                        flexDirection:"column",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setAprobacion1("100000000")}
                        disabled={aprobacion1 === "100000000"}
                        color="success"
                      >
                        Aceptar
                      </Button>
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setAprobacion1("100000001")}
                        disabled={aprobacion1 === "100000001"}
                        color="error"
                      >
                        Rechazar
                      </Button>
                    </Box>
                  </Box> 
                </Grid>
              </>
            )}
            {idAprobador2 === empleado.empleadoid && (
              <>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
                  <CustomTextField Component={TextField} name="nombreAprobador2" label="Aprobador 2" />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                      ¿Que acción desea realizar?
                    </Typography>
                    <Box
                      sx={{
                        minWidth: "100%",
                        display: "flex",
                        flexDirection:"column",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setAprobacion2("100000000")}
                        disabled={aprobacion2 === "100000000"}
                        color="success"
                      >
                        Aceptar
                      </Button>
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setAprobacion2("100000001")}
                        disabled={aprobacion2 === "100000001"}
                        color="error"
                      >
                        Rechazar
                      </Button>
                    </Box>
                  </Box> 
                </Grid>
              </>
            )}
            {idAprobador3 === empleado.empleadoid && (
              <>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
                  <CustomTextField Component={TextField} name="nombreAprobador3" label="Aprobador 3" />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                      ¿Que acción desea realizar?
                    </Typography>
                    <Box
                      sx={{
                        minWidth: "100%",
                        display: "flex",
                        flexDirection:"column",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setAprobacion3("100000000")}
                        disabled={aprobacion3 === "100000000"}
                        color="success"
                      >
                        Aceptar
                      </Button>
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setAprobacion3("100000001")}
                        disabled={aprobacion3 === "100000001"}
                        color="error"
                      >
                        Rechazar
                      </Button>
                    </Box>
                  </Box> 
                </Grid>
              </>
            )}
            {/* <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
              <CustomTextField Component={TextField} name="usuarioPortalAprobador1" label="Usuario portal aprobador 1" />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
              <CustomTextField Component={TextField} name="usuarioPortalAprobador2" label="Usuario portal aprobador 2" />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
              <CustomTextField Component={TextField} name="usuarioPortalAprobador3" label="Usuario portal aprobador 3" />
            </Grid> */}
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={loadAprobarRechazarVacacionEquipoSelector === "LOADING"}
                onClick={handleSubmit(aprobarVacacionesEquipo)}
              >
                Enviar
              </Button>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </Dialog>
  )
})

export default ModalVacacionesEquipo
